/**
 * Builds the post-save status text for the course editor (Spanish copy via locales).
 * @param {{
 *   cambiosAplicados?: ReadonlyArray<Record<string, string | number>>,
 *   cambiosPendientes?: ReadonlyArray<Record<string, string | number>>,
 *   aplicados?: ReadonlyArray<{ campo?: string }>,
 *   pendientes?: ReadonlyArray<{ campo?: string }>,
 * }} data
 * @param {{ fieldLabels?: Readonly<Record<string, string>> }} [options]
 * @returns {string}
 */
export function formatCourseEditSaveFeedback() {
  return "✅ Cambios guardados.";
}
